import { View } from '@gluestack-ui/themed'
import React, { FunctionComponent } from 'react'
import { StyleSheet } from 'react-native'
import { useSelector } from 'react-redux'
import { themeSelector } from '../../../redux/theme/selector'
import { ViewProps } from '../../../redux/theme/types'

export const CardItem: FunctionComponent<ViewProps> = ({ style, ...props }) => {
  const theme = useSelector(themeSelector)
  return <View style={[styles.content, { backgroundColor: theme?.containerBgColor }, style]} {...props} />
}

const styles = StyleSheet.create({
  content: {
    flex: 1,
    flexDirection: 'row',
  },
})
